export const NAV_LINKS = [
  { label: 'Inicio', path: '/' },
  {
    label: 'Soluciones',
    dropdown: true,
    items: [
      { icon: 'HeartPulse', label: 'FitRewards', path: '/fitrewards' },
      { icon: 'HeartHandshake', label: 'Reconocimiento Laboral', path: '/reconocimiento-laboral' },
      { icon: 'MessageSquare', label: 'Comunicación Interna', path: '/comunicacion-interna' },
      { icon: 'Crown', label: 'Fidelización de Clientes', path: '/fidelizacion-de-clientes' },
      { icon: 'Brain', label: 'Salud Mental', path: '/salud-mental' },
      { icon: 'Stethoscope', label: 'MotiCare', path: '/moticare' },
    ],
  },
  { label: 'Proveedores', path: '/proveedores' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Blog', path: '/blog' },
  {
    label: 'Legal',
    dropdown: true,
    items: [
      { icon: 'Shield', label: 'Política de Privacidad', path: '/politica-de-privacidad' },
      { icon: 'HeartPulse', label: 'Privacidad FitRewards', path: '/politica-de-privacidad/fitrewards' },
    ],
  },
];

export const TYPEFORM_URL = 'https://motivy.typeform.com/to/W6TKgjmc?typeform-source=motivyapp.com';
export const CALENDLY_URL = 'https://calendly.com/aperez-35/intro-motivy';
export const YOUTUBE_CHANNEL = 'https://www.youtube.com/@MotivyApp';

export const HERO_DATA = {
  heading: 'Motiva, reconoce y potencia a tu equipo desde una sola plataforma',
  subtitle: 'Engagement, bienestar, comunicación interna y fidelización. Todo lo que necesitas para construir una cultura organizacional extraordinaria, en un solo lugar.',
  image: 'https://customer-assets.emergentagent.com/job_f9c22ad0-e2e2-448c-9e83-2d2336da22aa/artifacts/rrp1jm6u_image.png',
};

export const PRODUCTS = [
  {
    title: 'Reconocimiento Laboral',
    description: 'Impulsa una cultura laboral donde reconocer a los demás es parte del día a día. Fomenta el orgullo, la conexión y el sentido de propósito.',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&h=400&fit=crop',
    link: '/reconocimiento-laboral',
    icon: 'HeartHandshake',
  },
  {
    title: 'Comunicación Interna',
    description: 'Centraliza el envío de comunicaciones corporativas y accede a nuestro panel omni canal y bots de asistencia virtual.',
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&h=400&fit=crop',
    link: '/comunicacion-interna',
    icon: 'MessageSquare',
  },
  {
    title: 'Fidelización de Clientes',
    description: 'Transforma la relación con tus clientes con programas de lealtad personalizados y beneficios exclusivos.',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop',
    link: '/fidelizacion-de-clientes',
    icon: 'Crown',
  },
  {
    title: 'FitRewards',
    description: 'Tu bienestar recompensado. Conecta tus wearables, monitorea tu bienestar en tiempo real y disfruta de un catálogo de premios.',
    image: 'https://motivyapp.com/wp-content/uploads/2024/07/Recurso-2.svg',
    link: '/fitrewards',
    icon: 'HeartPulse',
    isSvg: true,
  },
  {
    title: 'Salud Mental',
    description: 'Plataforma integral de salud mental con contenido, herramientas de autogestión y atención profesional 24/7.',
    image: 'https://images.unsplash.com/photo-1767605982668-2f007a846e2c?w=600&h=400&fit=crop',
    link: '/salud-mental',
    icon: 'Brain',
  },
  {
    title: 'MotiCare',
    description: 'Solución integral que combina telemedicina, psicología, nutrición y engagement para colaboradores más sanos y felices.',
    image: 'https://motivyapp.com/wp-content/uploads/2025/04/undraw_mobile-application_lhsq.svg',
    link: '/moticare',
    icon: 'Stethoscope',
    isSvg: true,
  },
];

export const BENEFITS = [
  { icon: 'PackageX', text: 'Despreocúpate de bonos, recompensas, beneficios corporativos y su logística.' },
  { icon: 'Settings', text: 'Simplifica la organización y ejecución de programas corporativos ahorrando costos y tiempos.' },
  { icon: 'TrendingUp', text: 'Asegura la escalabilidad de tu negocio siendo más transversal y rompiendo silos.' },
  { icon: 'Gamepad2', text: 'Gana en productividad a través del reconocimiento público y compromiso mediante gamificación.' },
  { icon: 'Ticket', text: 'Complementa tu plan de compensación con nuestra cuponera para tus colaboradores.' },
  { icon: 'Award', text: 'Mejora tu marca empleadora.' },
];

export const SUCCESS_METRICS = [
  { stat: '+50', description: 'Empresas confían en nosotros para transformar su cultura' },
  { stat: '+300K', description: 'Usuarios activos utilizando nuestra plataforma' },
  { stat: '+22M', description: 'Puntos otorgados a colaboradores' },
  { stat: '+10M', description: 'Reconocimientos sociales enviados' },
  { stat: '+70%', description: 'Índice de participación en iniciativas' },
];

export const IMPLEMENTATION_STEPS = [
  {
    icon: 'Lightbulb',
    title: 'Asesoría estratégica',
    description: 'Te acompañamos en la integración de la plataforma, el desarrollo de programas personalizados e implementación de objetivos.',
  },
  {
    icon: 'GraduationCap',
    title: 'Capacitación',
    description: 'Preparamos y capacitamos a los administradores, líderes de equipo y embajadores Motivy para impulsar el cambio.',
  },
  {
    icon: 'Headphones',
    title: 'Acompañamiento continuo',
    description: 'Nos quedamos contigo después del lanzamiento. Te ayudamos a mantener el nivel de engagement y medimos índices clave.',
  },
];

export const TESTIMONIALS = [
  {
    initials: 'FM',
    name: 'Francisco M.',
    role: 'Gerente General',
    quote: 'Excelente herramienta para incrementar la productividad y el compromiso de los colaboradores.',
  },
  {
    initials: 'AR',
    name: 'Arturo R.',
    role: 'Product Developer',
    quote: 'Motivy nos ha permitido reconocer a quienes mejoran cada día. Hace público lo que una persona ha conseguido y se les recompensa.',
  },
  {
    initials: 'MG',
    name: 'Ma Elena G.',
    role: 'Product Development',
    quote: 'Una herramienta fácil de usar, a la gente le gusta recibir recompensas y los puntos los motivan a mejorar.',
  },
];

export const BLOG_POSTS = [
  {
    date: 'Abril 2, 2025',
    title: 'Tendencias en Gestión del Talento: ¿Cómo Prepararse para el Futuro del Trabajo?',
    excerpt: 'El mundo laboral está evolucionando rápidamente debido a la tecnología, la inteligencia artificial y los nuevos modelos de trabajo...',
    image: 'https://images.unsplash.com/photo-1590650046871-92c887180603?w=600&h=400&fit=crop',
    slug: 'tendencias-gestion-del-talento',
  },
  {
    date: 'Marzo 26, 2025',
    title: '¿Gamificación en el Trabajo? Cómo Transformar la Motivación con Estrategias de Juego',
    excerpt: 'Imagina que cada tarea diaria en el trabajo viniera acompañada de un reto estimulante...',
    image: 'https://images.pexels.com/photos/7691694/pexels-photo-7691694.jpeg?w=600&h=400&fit=crop',
    slug: 'gamificacion-en-el-trabajo',
  },
  {
    date: 'Marzo 13, 2025',
    title: 'MotiCare y FitRewards: Innovando el Bienestar en las Empresas',
    excerpt: 'En un mundo donde la salud y el bienestar son fundamentales para la productividad...',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=400&fit=crop',
    slug: 'moticare-fitrewards',
  },
  {
    date: 'Febrero 26, 2025',
    title: 'El Reconocimiento Entre Pares: Clave para una Cultura Organizacional Positiva',
    excerpt: 'En muchas empresas, el reconocimiento suele provenir exclusivamente de los niveles superiores...',
    image: 'https://images.pexels.com/photos/3860619/pexels-photo-3860619.jpeg?w=600&h=400&fit=crop',
    slug: 'reconocimiento-entre-pares',
  },
  {
    date: 'Febrero 19, 2025',
    title: 'El Rol del Reconocimiento en la Reducción de la Rotación Laboral',
    excerpt: 'La rotación laboral es uno de los problemas más costosos para las organizaciones...',
    image: 'https://images.pexels.com/photos/6457579/pexels-photo-6457579.jpeg?w=600&h=400&fit=crop',
    slug: 'reconocimiento-reduccion-rotacion',
  },
  {
    date: 'Febrero 5, 2025',
    title: 'Programas de Fidelización y Experiencia del Cliente: Estrategia Ganadora',
    excerpt: 'En un mercado altamente competitivo, la fidelización de clientes se ha convertido en prioridad...',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop',
    slug: 'programas-de-fidelizacion',
  },
  {
    date: 'Enero 29, 2025',
    title: 'La Ciencia Detrás de la Motivación: ¿Qué Nos Impulsa a Actuar?',
    excerpt: 'La motivación es el motor que impulsa nuestras acciones, nos da propósito y dirección...',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&h=400&fit=crop',
    slug: 'ciencia-motivacion-impulso',
  },
  {
    date: 'Enero 22, 2025',
    title: 'Programas de Reconocimiento y su Rol en el Desarrollo Profesional',
    excerpt: 'En el entorno laboral actual, las empresas enfrentan el reto de retener talento...',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop',
    slug: 'programas-reconocimiento-desarrollo',
  },
  {
    date: 'Enero 15, 2025',
    title: 'Maximiza el ROI de tu Programa de Fidelización con Análisis de Datos',
    excerpt: 'En un entorno empresarial cada vez más competitivo, la fidelización de clientes es clave...',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop',
    slug: 'roi-fidelizacion-datos',
  },
];

export const FAQ_ITEMS = [
  {
    question: '¿Qué es Motivy?',
    answer: 'Motivy es una plataforma de capital humano y bienestar corporativo que ayuda a las empresas a mejorar el engagement de sus colaboradores, reconocer su trabajo, fomentar hábitos saludables y fidelizar clientes mediante tecnología innovadora.',
  },
  {
    question: '¿Qué es FitRewards?',
    answer: 'FitRewards es la aplicación de bienestar de Motivy que convierte hábitos saludables en recompensas reales. Los colaboradores ganan puntos por actividad física, alimentación saludable, descanso y autocuidado. Se conecta con wearables como Apple Watch, Fitbit y Google Fit.',
  },
  {
    question: '¿Cuántas empresas usan Motivy?',
    answer: 'Más de 50 empresas confían en Motivy con más de 300,000 usuarios activos, +22M puntos otorgados y +10M reconocimientos sociales enviados en toda la región.',
  },
  {
    question: '¿Motivy ofrece soluciones de salud mental?',
    answer: 'Sí, Motivy ofrece una plataforma integral de salud mental que incluye +500 horas de contenido especializado, meditación guiada, telepsicología 24/7, journaling digital, mood tracker y chatbot de ayuda emocional con IA.',
  },
  {
    question: '¿Cómo es el proceso de implementación?',
    answer: 'El proceso incluye tres fases: 1) Asesoría estratégica donde diseñamos tu programa personalizado, 2) Capacitación de administradores y líderes de equipo, 3) Acompañamiento continuo post-lanzamiento con medición de KPIs y engagement.',
  },
  {
    question: '¿Motivy se integra con otros sistemas?',
    answer: 'Sí, Motivy se integra con los principales sistemas de RRHH, ERP, y herramientas de comunicación como Slack, Microsoft Teams, y más. También se conecta con wearables (Apple Watch, Fitbit, Google Fit) para FitRewards.',
  },
  {
    question: '¿Cómo puedo ser proveedor de Motivy?',
    answer: 'Si tu empresa ofrece productos o servicios que pueden formar parte de nuestro catálogo de recompensas, visita nuestra sección de Proveedores o contáctanos directamente para explorar la alianza.',
  },
  {
    question: '¿Qué es MotiCare?',
    answer: 'MotiCare es la solución integral de bienestar de Motivy que combina telemedicina, psicología, nutrición y engagement para colaboradores más sanos y felices. Incluye consultas médicas 24/7, planes de nutrición personalizados y seguimiento de salud integral.',
  },
];

export const FOOTER_SOLUTIONS = [
  { label: 'FitRewards', path: '/fitrewards' },
  { label: 'Reconocimiento Laboral', path: '/reconocimiento-laboral' },
  { label: 'Comunicación Interna', path: '/comunicacion-interna' },
  { label: 'Fidelización de Clientes', path: '/fidelizacion-de-clientes' },
  { label: 'Salud Mental', path: '/salud-mental' },
  { label: 'MotiCare', path: '/moticare' },
];

export const FOOTER_COMPANY = [
  { label: 'Proveedores', path: '/proveedores' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Blog', path: '/blog' },
  { label: 'Contacto', path: '/contacto' },
];

// ============ Solution Page Data ============

export const RECONOCIMIENTO_DATA = {
  hero: {
    heading: 'Reconocimiento Laboral',
    subtitle: 'Impulsa una cultura laboral donde reconocer a los demás es parte del día a día. Fomenta el orgullo, la conexión y el sentido de propósito en cada equipo.',
    image: 'https://customer-assets.emergentagent.com/job_f9c22ad0-e2e2-448c-9e83-2d2336da22aa/artifacts/ku1599bn_image.png',
  },
  features: [
    { icon: 'Award', title: 'Reconocimiento social', description: 'Empodera a todos los colaboradores a reconocer públicamente a sus colegas atado a valores corporativos y habilidades blandas.' },
    { icon: 'Shield', title: 'Insignias personalizadas', description: 'Crea y asigna insignias únicas que representen logros, competencias y valores de tu organización.' },
    { icon: 'Coins', title: 'Sistema de puntos', description: 'Los colaboradores acumulan puntos por reconocimientos recibidos y pueden canjearlos por recompensas reales.' },
    { icon: 'Gift', title: 'Catálogo de recompensas', description: 'Amplio catálogo con tarjetas de regalo, experiencias, productos y beneficios corporativos exclusivos.' },
    { icon: 'Gamepad2', title: 'Gamificación', description: 'Rankings, retos y badges que fomentan la competencia sana y mantienen la participación activa.' },
    { icon: 'BarChart3', title: 'Analítica en tiempo real', description: 'Dashboards con métricas de engagement, top reconocedores, valores más reforzados y tendencias.' },
  ],
  stats: [
    { stat: '+35%', description: 'Mejora en retención de talento' },
    { stat: '+70%', description: 'Incremento en participación' },
    { stat: '-40%', description: 'Reducción en rotación laboral' },
    { stat: '+25%', description: 'Aumento en productividad' },
  ],
  audiences: [
    { icon: 'Building2', title: 'Empresas en crecimiento', description: 'Organizaciones que escalan rápidamente y necesitan mantener su cultura sin perder la cercanía entre equipos. Ideal para startups y scale-ups con equipos remotos que buscan fomentar el sentido de pertenencia.' },
    { icon: 'Factory', title: 'Manufactura y operaciones', description: 'Industrias donde el personal operativo en planta necesita sentirse valorado y conectado con los objetivos. Reduce la rotación de primera línea y mejora la moral del equipo con reconocimiento tangible.' },
    { icon: 'Landmark', title: 'Banca y servicios financieros', description: 'Sector donde la retención de talento especializado es prioridad competitiva. Fortalece la cultura de servicio, reconoce el cumplimiento de metas comerciales y promueve valores institucionales.' },
  ],
};

export const COMUNICACION_DATA = {
  hero: {
    heading: 'Comunicación Interna',
    subtitle: 'Centraliza y potencia las comunicaciones corporativas de tu empresa con un panel omnicanal inteligente que conecta a todos tus colaboradores.',
    image: 'https://customer-assets.emergentagent.com/job_f9c22ad0-e2e2-448c-9e83-2d2336da22aa/artifacts/7xfwisx6_image.png',
  },
  features: [
    { icon: 'LayoutDashboard', title: 'Panel omnicanal', description: 'Envía comunicaciones por email, push, SMS, WhatsApp y la app desde un solo panel centralizado.' },
    { icon: 'Bot', title: 'Bots de asistencia', description: 'Chatbots virtuales que responden preguntas frecuentes de RRHH, TI y políticas internas 24/7.' },
    { icon: 'Users', title: 'Segmentación inteligente', description: 'Segmenta audiencias por área, ubicación, antigüedad o cualquier atributo para mensajes personalizados.' },
    { icon: 'Zap', title: 'Automatización', description: 'Programa comunicados automáticos para onboarding, cumpleaños, aniversarios y fechas clave.' },
    { icon: 'BarChart3', title: 'Métricas de alcance', description: 'Mide tasas de apertura, lectura y engagement de cada comunicación enviada.' },
    { icon: 'Bell', title: 'Notificaciones push', description: 'Alertas instantáneas en la app para comunicados urgentes y recordatorios importantes.' },
  ],
  stats: [
    { stat: '+80%', description: 'Tasa de lectura de comunicados' },
    { stat: '-60%', description: 'Reducción en tickets de RRHH' },
    { stat: '+45%', description: 'Mejora en alineación cultural' },
    { stat: '+68', description: 'NPS promedio de satisfacción interna' },
  ],
  audiences: [
    { icon: 'Globe', title: 'Empresas multipaís', description: 'Organizaciones con presencia en múltiples países que necesitan comunicación unificada y segmentada por región, idioma y zona horaria.' },
    { icon: 'HardHat', title: 'Personal sin escritorio', description: 'Industrias con colaboradores en planta, campo, tiendas o retail que no acceden a email corporativo. Llega a todos con push notifications.' },
    { icon: 'GitMerge', title: 'Empresas en transformación', description: 'Organizaciones atravesando fusiones, adquisiciones o cambios culturales que necesitan alinear mensajes.' },
  ],
};

export const FIDELIZACION_DATA = {
  hero: {
    heading: 'Fidelización de Clientes',
    subtitle: 'Transforma la relación con tus clientes con programas de lealtad personalizados que aumentan la retención, el ticket promedio y el lifetime value.',
    videoUrl: 'https://www.youtube.com/embed/sawHcoNXAc8',
  },
  features: [
    { icon: 'Star', title: 'Programas de puntos', description: 'Crea programas de acumulación de puntos personalizados con reglas flexibles de acuerdo a tu modelo de negocio.' },
    { icon: 'Layers', title: 'Niveles y categorías', description: 'Diseña niveles (Silver, Gold, Platinum) que premian la lealtad y motivan a tus clientes a subir de categoría.' },
    { icon: 'Target', title: 'Campañas dirigidas', description: 'Lanza campañas segmentadas con ofertas personalizadas basadas en comportamiento e historial de compra.' },
    { icon: 'ShoppingBag', title: 'Catálogo de premios', description: 'Ofrece un catálogo atractivo donde los clientes canjean puntos por productos, descuentos y experiencias.' },
    { icon: 'PieChart', title: 'Analítica de comportamiento', description: 'Dashboards con insights sobre patrones de compra, frecuencia, segmentos más rentables y predicción de churn.' },
    { icon: 'Plug', title: 'Integraciones POS/CRM', description: 'Conecta con tu punto de venta, e-commerce y CRM para automatizar la acumulación y canje de puntos.' },
  ],
  stats: [
    { stat: '+35%', description: 'Crecimiento en NPS' },
    { stat: '+20%', description: 'Incremento en ticket promedio' },
    { stat: '+60%', description: 'Aumento en tasa de recompra' },
    { stat: '-30%', description: 'Reducción en costo de adquisición' },
  ],
  audiences: [
    { icon: 'Store', title: 'Retail y comercio', description: 'Cadenas de tiendas, e-commerce y marketplaces que buscan aumentar la frecuencia de compra y el ticket promedio.' },
    { icon: 'Utensils', title: 'Restaurantes y hospitalidad', description: 'Hoteles, restaurantes y cadenas que quieren crear experiencias memorables y clientes recurrentes.' },
    { icon: 'CreditCard', title: 'Servicios financieros', description: 'Bancos, fintechs y aseguradoras que buscan retener clientes con programas de beneficios diferenciados.' },
  ],
};

export const SALUD_MENTAL_DATA = {
  hero: {
    heading: 'Salud Mental',
    subtitle: 'Plataforma integral de bienestar mental para tus colaboradores. Más de 500 horas de contenido, herramientas de autogestión y acceso a profesionales 24/7.',
    image: 'https://customer-assets.emergentagent.com/job_motivy-light/artifacts/lfnecvww_saludmental.jpg',
  },
  features: [
    { icon: 'BookOpen', title: '+500 horas de contenido', description: 'Biblioteca especializada con contenido audiovisual sobre inteligencia emocional, manejo del estrés, mindfulness y más.' },
    { icon: 'Wind', title: 'Meditación guiada', description: 'Sesiones de mindfulness y meditación con técnicas basadas en evidencia para reducir la ansiedad.' },
    { icon: 'PenLine', title: 'Journaling digital', description: 'Diario emocional privado para reflexión, autoconocimiento y seguimiento del estado emocional.' },
    { icon: 'Smile', title: 'Mood tracker', description: 'Registro diario del estado de ánimo con visualizaciones que ayudan a identificar patrones emocionales.' },
    { icon: 'PhoneCall', title: 'Telepsicología 24/7', description: 'Acceso ilimitado a consultas con psicólogos profesionales por videollamada, chat o teléfono.' },
    { icon: 'Bot', title: 'Chatbot emocional con IA', description: 'Asistente virtual de ayuda emocional con inteligencia artificial para soporte inmediato.' },
    { icon: 'AlertCircle', title: 'Botón SOS emocional', description: 'Derivación inmediata a un profesional en situaciones de crisis emocional con seguimiento posterior.' },
    { icon: 'ClipboardCheck', title: 'Evaluaciones psicométricas', description: 'Tests validados (PHQ-9, GAD-7, burnout) para medir el bienestar emocional del equipo.' },
    { icon: 'BarChart3', title: 'Dashboard analítico', description: 'Métricas organizacionales de bienestar mental con KPIs y tendencias para toma de decisiones.' },
  ],
  stats: [
    { stat: '-45%', description: 'Reducción en ausentismo' },
    { stat: '+500', description: 'Horas de contenido' },
    { stat: '24/7', description: 'Atención disponible' },
    { stat: '+30%', description: 'Satisfacción laboral' },
  ],
  audiences: [
    { icon: 'Heart', title: 'Aseguradoras', description: 'Programas de prevención en salud mental a gran escala que reducen costos médicos y mejoran la siniestralidad.' },
    { icon: 'Headphones', title: 'Contact centers y BPOs', description: 'Empresas con alta rotación y estrés laboral que necesitan herramientas de soporte emocional permanente.' },
    { icon: 'Stethoscope', title: 'Sector salud y educación', description: 'Hospitales, clínicas y universidades con personal expuesto a burnout que requieren cuidado emocional continuo.' },
  ],
};

export const MOTICARE_DATA = {
  hero: {
    heading: 'MotiCare',
    subtitle: 'La solución integral que combina telemedicina, psicología, nutrición y engagement para colaboradores más sanos y felices. Todo en una sola plataforma.',
    image: 'https://motivyapp.com/wp-content/uploads/2025/04/undraw_mobile-application_lhsq.svg',
  },
  features: [
    { icon: 'Video', title: 'Telemedicina 24/7', description: 'Consultas médicas virtuales ilimitadas con médicos generales y especialistas disponibles las 24 horas.' },
    { icon: 'Brain', title: 'Atención psicológica', description: 'Sesiones con psicólogos profesionales por videollamada para el cuidado emocional de tus colaboradores.' },
    { icon: 'Apple', title: 'Asesoría nutricional', description: 'Planes de nutrición personalizados con seguimiento de nutriólogos certificados.' },
    { icon: 'HeartPulse', title: 'Seguimiento de salud', description: 'Monitoreo integral de indicadores de salud con alertas y recomendaciones personalizadas.' },
    { icon: 'Trophy', title: 'Engagement y retos', description: 'Retos de bienestar, gamificación y recompensas que motivan hábitos saludables sostenibles.' },
    { icon: 'FileText', title: 'Recetas electrónicas', description: 'Prescripción médica digital con envío directo al colaborador tras la teleconsulta.' },
  ],
  stats: [
    { stat: '-50%', description: 'Reducción en ausentismo laboral' },
    { stat: '+40%', description: 'Mejora en satisfacción del empleado' },
    { stat: '24/7', description: 'Atención médica disponible' },
    { stat: '-35%', description: 'Reducción en costos de salud' },
  ],
  audiences: [
    { icon: 'Shield', title: 'Aseguradoras', description: 'Solución de bienestar integral que reduce siniestralidad y complementa pólizas de salud.' },
    { icon: 'Building2', title: 'Grandes corporaciones', description: 'Empresas que buscan una solución completa de bienestar para miles de colaboradores.' },
    { icon: 'HardHat', title: 'Industria y manufactura', description: 'Compañías con personal operativo que necesitan acceso a salud sin desplazarse.' },
  ],
};

export const PROVEEDORES_DATA = {
  hero: {
    heading: 'Programa de Proveedores',
    subtitle: 'Forma parte de nuestro catálogo de recompensas y conecta tu marca con miles de colaboradores en empresas líderes de la región.',
    image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=600&fit=crop',
  },
  benefits: [
    { icon: 'Users', title: 'Acceso a +300K usuarios', description: 'Tu marca estará visible para más de 300,000 colaboradores activos que canjean puntos por productos y servicios diariamente.' },
    { icon: 'Building2', title: '+50 empresas clientes', description: 'Conéctate con empresas líderes de múltiples industrias que ya confían en Motivy para sus programas de bienestar y reconocimiento.' },
    { icon: 'TrendingUp', title: 'Canal de venta B2B2C', description: 'Nuevo canal de ventas para tu negocio con un público altamente segmentado y listo para consumir tus productos o servicios.' },
    { icon: 'ShieldCheck', title: 'Plataforma segura', description: 'Integración sencilla y segura. Nos encargamos de la logística de canjes y entregas para que tú te enfoques en tu negocio.' },
    { icon: 'BarChart3', title: 'Reportes y métricas', description: 'Accede a dashboards con datos sobre canjes, preferencias de usuarios y rendimiento de tus productos dentro de la plataforma.' },
    { icon: 'Handshake', title: 'Alianza estratégica', description: 'Más que un proveedor, un socio. Te acompañamos con campañas especiales, visibilidad premium y co-marketing.' },
  ],
};
